/* FJC: no half-filled last row above "Load more" on collection pages.

   Globo loads a fixed batch of products (72), then our card template
   (snippets/globo.filter.product.liquid) drops the sold-out ones, so a batch
   is often a few cards short and the last row before "Load more" is ragged
   (e.g. Rings: 67 cards, 3 on the bottom row).

   After every Globo render, while "Load more" is showing, the cards in an
   incomplete last row are hidden. On the next render (Load more, filter,
   sort) every card is shown again first, so the hidden ones reappear at the
   start of the next batch and no product is skipped. With no more pages
   everything is shown. Re-checked on resize, as the column count changes. */
(function () {
  var ATTR = 'data-fjc-row-trim';

  function trimLastRow() {
    var grid = document.getElementById('gf-products');
    if (!grid) return;

    var trimmed = grid.querySelectorAll('[' + ATTR + ']');
    for (var i = 0; i < trimmed.length; i++) {
      trimmed[i].style.removeProperty('display');
      trimmed[i].removeAttribute(ATTR);
    }

    var more = document.querySelector('#gf_pagination_wrap .gf-loadmore-btn');
    if (!more || !more.offsetParent) return;

    var style = getComputedStyle(grid);
    if (style.display !== 'grid') return;
    var tracks = style.gridTemplateColumns.split(' ').filter(Boolean);
    var cols = tracks.length;
    if (cols < 2) return;
    var colWidth = parseFloat(tracks[0]);
    var gap = parseFloat(style.columnGap) || 0;
    if (!colWidth) return;

    // Cards on the last row, by position (editorial tiles can span rows and columns).
    var cards = grid.querySelectorAll(':scope > .grid-item');
    if (!cards.length) return;
    var lastTop = -Infinity;
    for (var c = 0; c < cards.length; c++) {
      if (!cards[c].offsetParent) continue;
      lastTop = Math.max(lastTop, cards[c].getBoundingClientRect().top);
    }
    if (lastTop === -Infinity) return;

    // Columns filled on that row, counting any tile that reaches down into it.
    var used = 0;
    var rowCards = [];
    var items = grid.children;
    for (var k = 0; k < items.length; k++) {
      var el = items[k];
      if (!el.offsetParent) continue;
      var r = el.getBoundingClientRect();
      if (r.top > lastTop + 1 || r.bottom <= lastTop + 1) continue;
      used += Math.max(1, Math.round((r.width + gap) / (colWidth + gap)));
      if (el.classList.contains('grid-item') && Math.abs(r.top - lastTop) < 1) rowCards.push(el);
    }
    if (used >= cols) return;

    for (var n = 0; n < rowCards.length; n++) {
      rowCards[n].setAttribute(ATTR, '');
      rowCards[n].style.setProperty('display', 'none', 'important');
    }
  }

  // Deferred so the editorial tiles (snippets/promotion-block2.liquid), inserted
  // on the same event, are already in place.
  function schedule() {
    setTimeout(trimLastRow, 0);
  }

  window.addEventListener('globoFilterRenderCompleted', schedule);

  var resizeTimer;
  var lastWidth = window.innerWidth;
  window.addEventListener('resize', function () {
    if (window.innerWidth === lastWidth) return;
    lastWidth = window.innerWidth;
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(trimLastRow, 200);
  });

  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
})();
